export default __webpack_public_path__ + "static/media/portfolio-68.b292816d.jpg";